module.exports = __webpack_public_path__ + "static-v-shop/1792141392954/img/cybermonday-marcas-desktop.21947dca.png";